import { Component, OnInit } from '@angular/core';
import { loadingFade, modal, alert } from '../../animacoes';
import { DocumentosService } from '../services/documentos.service';
import { AuthService } from '../services/auth.service';
import { DomSanitizer } from '@angular/platform-browser';
import { environment } from 'src/environments/environment';
import { PerfilUsuarioService } from '../services/perfil-usuario.service';
import { ActivatedRoute, Router } from "@angular/router";

import Swal from 'sweetalert2';

@Component({
  selector: 'app-documentos',
  templateUrl: './documentos.component.html',
  styleUrls: ['./documentos.component.css'],
  animations: [loadingFade]
})
export class DocumentosComponent implements OnInit {

	public menu_id = 166;
	public loading = false;
	public documentos = [];
	public bairro_array = [];

	public arquivos = [];

	// paginacao
	public page = 1;
	public limit = 10;
	public count = 0;

	public arquivo_Exibe64:any;

	public perfil = this.authSvc.getPerfil();
	  
	public img_extensions = ['png', 'jpg', 'jpeg', 'bmp', 'gif'];

	//acesso
	public usuario_perfil;
	public visualizar = true;
	public editar = false;	
  
	constructor(private documentosSvc: DocumentosService,
				private authSvc : AuthService,
				private sanitizer: DomSanitizer,
				private router: Router,
				private route: ActivatedRoute,	
				private perfilUsuarioSvc: PerfilUsuarioService) { }


	ngOnInit() {

		//Verifica Permissões Acesso
		this.usuario_perfil = this.authSvc.getPerfil();
		this.perfilUsuarioSvc.getByVerificaPermissao(this.usuario_perfil,this.menu_id).then((data: any[]) => {
		if(data[0].editar){
			this.editar = true;
		}
		}).catch((err) => {
		console.log(err);
		});  	

		this.pegaDocumentos();
	}

  	primPagina() {
		this.page = 1;
	}

	paginaAnt() {
		this.page = Math.max(this.page - 1, 1);
	}

	proxPagina() {
		this.page = Math.min(this.page + 1, Math.ceil(this.count / this.limit));
	}

	ultPagina() {
		this.page = Math.ceil(this.count / this.limit);
	}

	pegaDocumentos(){
		this.documentos = [];
		this.loading = true;
		this.documentosSvc.getDocumentos().then((data: any[]) => {
			this.documentos = data;
			this.count = this.documentos.length;
			this.loading = false;
		}).catch((err) => {
			console.log(err);
			this.loading = false;
		})
	}

	apagaDocumento(id) {
		Swal.fire({
			type:'warning',
			title: 'Deseja realmente apagar este registro?',
			showCancelButton: true,
			showCloseButton: true,
			confirmButtonText: 'Apagar',
			cancelButtonText: 'Cancelar',
			confirmButtonColor: '#d33'
			  
		}).then((result) => {
			if(result.value == true){
				this.documentosSvc.apagaDocumento(id).then((data) => {
					this.pegaDocumentos();
					Swal.fire({
						type: 'success',
						title: 'Apagado com sucesso!'
					});
				}).catch((err) => {
					console.log(err);
					Swal.fire({
						type: 'error',
						title: 'Ops! Algo de errado aconteceu!',
						text: 'Não foi possível apagar este registro, tente novamente mais tarde.'
					});
				});
			}
		})
	}

	openFile($id){


		//this.loading = true;
		this.documentosSvc.getDocumentoArquivo($id).then((data) => {
		
			let dados = JSON.stringify(data);
			let obj = JSON.parse(dados);
			let objectURL = "";
			let tipo = obj.documento_arquivo_nome.substring(obj.documento_arquivo_nome.length - 3)
			
			if(tipo == "pdf"){
				 objectURL = 'data:application/pdf;base64,' + obj.documento_arquivo;
			}else{
				 objectURL = 'data:image/jpeg;base64,' + obj.documento_arquivo;
			}			

			//let objectURL = 'data:image/jpeg;base64,' + obj.documento_arquivo;
			//let objectURL = 'data:application/pdf;base64,' + obj.documento_arquivo;
			//let objectURL =  obj.documento_arquivo;
			//this.arquivo_Exibe64 = objectURL;

			const downloadLink = document.createElement('a');
			downloadLink.href = objectURL;
			downloadLink.download = "Documento_" + obj.documento_id;
			downloadLink.click();
			downloadLink.remove();

		}).catch((err) => {
			console.log(err);
			this.loading = false;
		})




		/*if(file_name == null){
			Swal.fire({
				width: '80%',
				imageUrl: environment.serviceApi + '/downloader/notfound.png',
				imageAlt: 'arquivo'
			});
		}
		let file_ext = file_name.split('.')[1];

		if(this.img_extensions.includes(file_ext)){
			Swal.fire({
				width: '80%',
				imageUrl: environment.serviceApi + '/downloader/' + file_name,
				imageAlt: 'arquivo'
			});
		}
		else{
			Swal.fire({
				html: '<a href="' + environment.serviceApi + '/downloader/' + file_name + '"><i class="fa fa-download" style="font-size: 64px;"></i><br>Baixar</a>',
			});
		}*/
  }

}
